import { render } from "./StickyTop.vue?vue&type=template&id=45ed42fb&scoped=true"
import script from "./StickyTop.vue?vue&type=script&lang=js"
export * from "./StickyTop.vue?vue&type=script&lang=js"

import "./StickyTop.vue?vue&type=style&index=0&id=45ed42fb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ed42fb"]])

export default __exports__